import { CSSProperties, useEffect, useState } from "react";
import { SiteSetting } from "app/umbraco/models/settings.model";
import { useSelector } from "react-redux";
import BlockSettings from "app/blocks/models/block-settings.interface";

const getCssProperties = (siteSettings: SiteSetting, blockSettings: BlockSettings): CSSProperties => {
    if (siteSettings) {
        const styles = {} as any;

        // Background color from block

        if (blockSettings?.backgroundColor) {
            styles["--background-color"] = blockSettings.backgroundColor;
        }

        // Indicators from Accordions block

        if (blockSettings?.indicatorColor) {
            styles["--indicator-color"] = `${blockSettings.indicatorColor}`;
        }

        let heading = undefined;
        let paragraph = undefined;
        let anchor = undefined;
        let anchorHover = undefined;

        // Text Color from block

        if (blockSettings?.textColor && blockSettings?.textColor.toUpperCase() === "LIGHT") {
            if (heading === undefined && siteSettings.theme?.lightHeadingColor) {
                heading = siteSettings.theme.lightHeadingColor;
            }

            if (paragraph === undefined && siteSettings.theme?.lightParagraphColor) {
                paragraph = siteSettings.theme.lightParagraphColor;
            }

            if (anchor === undefined && siteSettings.theme?.lightAnchorColor) {
                anchor = siteSettings.theme.lightAnchorColor;
            }

            if (anchorHover === undefined && siteSettings.theme?.lightAnchorHoverColor) {
                anchorHover = siteSettings.theme.lightAnchorHoverColor;
            }
        }
        else if (blockSettings?.textColor && blockSettings?.textColor.toUpperCase() === "DARK") {
            if (heading === undefined && siteSettings.theme?.darkHeadingColor) {
                heading = siteSettings.theme.darkHeadingColor;
            }

            if (paragraph === undefined && siteSettings.theme?.darkParagraphColor) {
                paragraph = siteSettings.theme.darkParagraphColor;
            }

            if (anchor === undefined && siteSettings.theme?.darkAnchorColor) {
                anchor = siteSettings.theme.darkAnchorColor;
            }

            if (anchorHover === undefined && siteSettings.theme?.darkAnchorHoverColor) {
                anchorHover = siteSettings.theme.darkAnchorHoverColor;
            }
        }
        else if (blockSettings?.textColor && blockSettings?.textColor.toUpperCase() === "WHITE") {
            if (heading === undefined) {
                heading = "#ffffff";
            }

            if (paragraph === undefined) {
                paragraph = "#ffffff";
            }

            if (anchor === undefined) {
                anchor = "#ffffff";
            }

            if (anchorHover === undefined) {
                anchorHover = "#ffffff";
            }
        }
        else if (blockSettings?.textColor && blockSettings?.textColor.toUpperCase() === "BLACK") {
            if (heading === undefined) {
                heading = "#000000";
            }

            if (paragraph === undefined) {
                paragraph = "#000000";
            }

            if (anchor === undefined) {
                anchor = "#000000";
            }

            if (anchorHover === undefined) {
                anchorHover = "#000000";
            }
        }

        // Text Color from theme

        else if (siteSettings.theme?.textColor && siteSettings.theme?.textColor.toUpperCase() === "LIGHT") {
            if (heading === undefined && siteSettings.theme?.lightHeadingColor) {
                heading = siteSettings.theme.lightHeadingColor;
            }

            if (paragraph === undefined && siteSettings.theme?.lightParagraphColor) {
                paragraph = siteSettings.theme.lightParagraphColor;
            }

            if (anchor === undefined && siteSettings.theme?.lightAnchorColor) {
                anchor = siteSettings.theme.lightAnchorColor;
            }

            if (anchorHover === undefined && siteSettings.theme?.lightAnchorHoverColor) {
                anchorHover = siteSettings.theme.lightAnchorHoverColor;
            }
        }
        else if (siteSettings.theme?.textColor && siteSettings.theme?.textColor.toUpperCase() === "WHITE") {
            if (heading === undefined) {
                heading = "#ffffff";
            }

            if (paragraph === undefined) {
                paragraph = "#ffffff";
            }

            if (anchor === undefined) {
                anchor = "#ffffff";
            }

            if (anchorHover === undefined) {
                anchorHover = "#ffffff";
            }
        }
        else if (siteSettings.theme?.textColor && siteSettings.theme?.textColor.toUpperCase() === "BLACK") {
            if (heading === undefined) {
                heading = "#000000";
            }

            if (paragraph === undefined) {
                paragraph = "#000000";
            }

            if (anchor === undefined) {
                anchor = "#000000";
            }

            if (anchorHover === undefined) {
                anchorHover = "#000000";
            }
        }
        else {
            if (heading === undefined && siteSettings.theme?.darkHeadingColor) {
                heading = siteSettings.theme.darkHeadingColor;
            }

            if (paragraph === undefined && siteSettings.theme?.darkParagraphColor) {
                paragraph = siteSettings.theme.darkParagraphColor;
            }

            if (anchor === undefined && siteSettings.theme?.darkAnchorColor) {
                anchor = siteSettings.theme.darkAnchorColor;
            }

            if (anchorHover === undefined && siteSettings.theme?.darkAnchorHoverColor) {
                anchorHover = siteSettings.theme.darkAnchorHoverColor;
            }
        }

        // Text Color output

        styles["--heading-color"] = heading;
        styles["--paragraph-color"] = paragraph;
        styles["--anchor-color"] = anchor;
        styles["--anchor-hover-color"] = anchorHover;


        // Embed block width and height
        
        if (blockSettings?.iframeWidth) {
            styles["--iframe-width"] = `${blockSettings.iframeWidth}px`;
        }

        if (blockSettings?.iframeHeight) {
            styles["--iframe-height"] = `${blockSettings.iframeHeight}px`;
        }


        return styles;
    }
    return {};
};

export default (blockSettings: BlockSettings): any => {
    const settings = useSelector(state => state.settings.content);
    const [result, setResult] = useState<CSSProperties>(getCssProperties(settings, blockSettings));

    useEffect(() => {
        setResult(getCssProperties(settings, blockSettings));
    }, [settings]);

    return result;
};